var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('v-main',{},[_c('div',{staticClass:"imgbox_2",style:(_vm.image_md_up)},[_c('v-container',[_c('v-row',{staticClass:"min-vh-100"},[_c('v-container',{attrs:{"fluid":""}},[_c('router-view')],1)],1)],1)],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }